import {msg} from "@lingui/macro"
import {useLingui} from "@lingui/react"
import {Box, Button, Card, CardContent, Grid, IconButton, Modal, Tab, Tabs, TextField, Typography} from "@mui/material"
import {Controller, useForm} from "react-hook-form"
import httpReq from "../../services/httpReq"
import {getAsiaUserFromLocalStorage} from "../../session/getAsiaUser"
import {useEffect, useState} from "react"
import CloseIcon from '@mui/icons-material/Close';
import FullPageLoader from "../loaders/FullPageLoader"
import UploadDropzone from "../uploadFile/UploadDropzone"
import UploadFileProgress from "../uploadFile/UploadFileProgress"
import useMobile from "../../hooks/useMobile";
import Autocomplete from "@mui/material/Autocomplete";

const ModalAddVideo = ({isOpen, setIsOpen, project, videoId, setVideoId, setGenerateTracks, setReloadVideosList}) => {
    const {_} = useLingui()
    const user = getAsiaUserFromLocalStorage()
    const isMobile = useMobile();
    const {control, formState, handleSubmit, getValues} = useForm({
        mode: 'onChange'
    })
    const [videoFile, setVideoFile] = useState({
        file: null,
        video: null
    });
    const [isLoading, setIsLoading] = useState(false)
    const [file, setFile] = useState(null);
    // Constant for the chunk size (10MB)
    const chunkSize = 1024 * 1024 * 10
    const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadMessage, setUploadMessage] = useState(null);
    const [localFilesList,setLocalFilesList] = useState([]);
    const [selectedLocalFile, setSelectedLocalFile] = useState(null);
    const [selectedUploadType,setSelectedUploadType] = useState(0);

    const uploadFile = async (isLocal = false) => {
        //setIsLoading(true)
        const formValues = getValues()
        if(!isLocal) {

            const splitFileType = file.type.split('/')
            const dataToSend = {
                id: 0,
                projectFk: project.id,
                title: formValues.title,
                description: formValues.description,
                fileName: file.name,
                fileExtension: '.' + splitFileType[1],
                fileMimeType: file.type
            }

            const res = await httpReq('Video/Insert', 'POST', dataToSend, true)
            if (!res || res.responseAnyError) return;
            if (!res.responseAnyError) {
                setVideoId(res.responseData.id)
                setCurrentChunkIndex(0);
                setIsUploading(true);
                setUploadMessage(null);
            }
        } else {
            const localFileNameSplit = selectedLocalFile.split('.')
            console.log('localFileNameSplit', localFileNameSplit)

            const dataToSendToUploadFile = {
                id: 0,
                projectFk: project.id,
                title: formValues.title,
                description: formValues.description,
                fileName: selectedLocalFile,
                fileExtension: '.' + selectedLocalFile[1],
                fileMimeType: selectedLocalFile[1]
            }
            const res = await httpReq('Video/Insert', 'POST', dataToSendToUploadFile, true)
            if (!res || res.responseAnyError) return;
            if(res && !res.responseAnyError){
                await uploadLocalFile(res.responseData)

            }
        }
    }

    const getLocalFiles = async () => {
        const res = await httpReq('Video/GetLocalFiles','GET',null,true);
        if (!res || res.responseAnyError) return;
        console.log('res getLocalFiles', res)
        if(res && !res.responseAnyError){
            setLocalFilesList(res.responseData)
            // setIsUploading(true);
        }
    }

    useEffect(() => {
        // Function to upload a chunk of the file
        async function uploadChunk(readerEvent) {
            if (!file || !videoId) return;

            const totalChunks = Math.ceil(file.size / chunkSize);
            const fileData = readerEvent.target.result;

            const body = {
                videoFk: videoId,
                chunkNumber: currentChunkIndex,
                totalChunks: totalChunks,
                chunkContent: fileData
            }

            const res = await httpReq('Video/UploadChunk', 'POST', body, true)
            if (!res || res.responseAnyError) return;
            if (!res.responseAnyError) {
                // Check if this is the last chunk
                const isLastChunk = currentChunkIndex === Math.ceil(file.size / chunkSize) - 1;
                // If it is, set the final filename and reset the current chunk index
                if (isLastChunk) {
                    setCurrentChunkIndex(null);
                    setIsUploading(false);
                    setUploadMessage(res.responseMessage);
                    setGenerateTracks(true)
                    setTimeout(() => {
                        setIsOpen(false);
                        setReloadVideosList(true)
                    }, 2000)
                } else {
                    // If it's not, increment the current chunk index
                    setCurrentChunkIndex(currentChunkIndex + 1);
                }
            }
            /*
            const headers = { 'Content-Type': 'application/json' };
            const url = 'https://localhost:56547/Video/UploadChunk/';

            // Make the POST request to the server
            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body)
            }).then(response => response.json())
                .then(res => {
                    // Check if this is the last chunk
                    const isLastChunk = currentChunkIndex === Math.ceil(file.size / chunkSize) - 1;
                    // If it is, set the final filename and reset the current chunk index
                    if (isLastChunk) {
                        setCurrentChunkIndex(null);
                        setIsUploading(false);
                        setUploadMessage(res.responseMessage);
                    } else {
                        // If it's not, increment the current chunk index
                        setCurrentChunkIndex(currentChunkIndex + 1);
                    }
                });
                */
        }

        // Function to read and upload the current chunk
        function readAndUploadCurrentChunk() {
            if (!file) return;
            // Calculate the start and end of the current chunk
            const from = currentChunkIndex * chunkSize;
            const to = (currentChunkIndex + 1) * chunkSize >= file.size ? file.size : from + chunkSize;

            // Slice the file to get the current chunk
            const blob = file.slice(from, to);

            const reader = new FileReader();
            // Set the onload function to upload the chunk when it's read
            reader.onload = e => uploadChunk(e);
            // Read the blob as a data URL
            reader.readAsDataURL(blob);
        }

        // If a chunk index is set, read and upload the current chunk
        if (currentChunkIndex != null) readAndUploadCurrentChunk();
    }, [chunkSize, currentChunkIndex, file])

    useEffect(() => {
        getLocalFiles()
    }, []);


    const saveVideo = async () => {
        setIsLoading(true)
        const formValues = getValues()
        const dataToSend = {
            projectFk: project.id,
            title: formValues.title,
            description: formValues.description
        }

        const res = await httpReq('Video/Insert', 'POST', dataToSend, true)
        if (!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            /*
            const formData = new FormData()
            const blob = new Blob([videoFile.file], { type: videoFile.type });
            formData.append('file', videoFile.file)

            const r = await httpReqFiles(`Video/Upload/${res.responseData.id}`, 'POST', formData, true)
            if (!r.responseAnyError) {
                setIsOpen(false)
                setIsLoading(false)
            }
                */
            return true
        }

    }

    const uploadLocalFile = async (insertResponse) => {
        const body = {
            videoFk: insertResponse.id,
            fileName: selectedLocalFile
        }
        console.log('body local file --> ', body)
        const res = await httpReq('Video/CopyLocalFile', 'POST', body, true)
        console.log('res local file --> ',res)
        if (!res || res.responseAnyError) return;
        if(res && !res.responseAnyError){
            setIsOpen(false);
            setReloadVideosList(true)
            setVideoId(res.responseData.id)
            setGenerateTracks(true)
        }
    }

    const  handleVideoUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVideoFile({
                file: file,
                video: URL.createObjectURL(file)
            })
        }

    };


    const perc = file ? Math.round(currentChunkIndex / Math.ceil(file.size / chunkSize) * 100) : 0;

    return (
        <>
            <Modal sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} open={isOpen}>
                <Card sx={{
                    width: !isMobile ? '50vw' : '100vw',
                    height: isMobile ? '100vh' : '80vh',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: 2,
                            py: 1.5,
                        }}
                    >
                        <Box sx={{flex: 1}}/>

                        <Typography variant="h6" align="center" sx={{flex: 1}}>
                            {`Add video to project`}
                        </Typography>

                        <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1}}>
                            {/**
                             <Button sx={{ borderRadius: 10 }} variant="contained" disabled={!formState.isValid || !videoFile.video} onClick={() => saveVideo()}>
                             <SaveIcon color={!formState.isValid || !videoFile ? 'inherit' : 'white'} />
                             </Button>
                             */}
                            <IconButton onClick={() => {setIsOpen(false); setReloadVideosList(true)}}><CloseIcon color="error"/></IconButton>
                        </Box>
                    </Box>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <Controller
                                    name='title'
                                    control={control}
                                    defaultValue=""
                                    rules={{required: _(msg`Title is required`)}}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            label={_(msg`Title`)}
                                            autoComplete='title'
                                            autoFocus
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name='description'
                                    control={control}
                                    rules={{required: _(msg`Description is required`)}}
                                    defaultValue=""
                                    render={({field, fieldState}) => (
                                        <TextField
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            label={_(msg`Description`)}
                                            autoComplete='description'
                                            autoFocus
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            {!isUploading && !uploadMessage && (
                                <Box sx={{display:'flex',flexDirection:'column',width:'100%'}}>
                                    <Tabs variant="fullWidth" sx={{marginBottom:4,display:'flex',flex:1,width:'100%'}} value={selectedUploadType} onChange={(e,newValue) => {
                                        setSelectedUploadType(newValue)
                                    }}>
                                        <Tab sx={{display:'flex',flex:1}} label={'Upload video'}></Tab>
                                        <Tab sx={{display:'flex',flex:1}} label={'Upload file from server'}></Tab>
                                    </Tabs>
                                    {selectedUploadType === 0 ? (
                                        <Grid item xs={12} display={'flex'} flexDirection={'row'} justifyContent={'center'}>
                                            <UploadDropzone
                                                disabled={!formState.isValid}
                                                selectedFile={file}
                                                setSelectedFile={setFile}
                                                uploadAction={uploadFile}
                                            />
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                                            <Autocomplete
                                                sx={{ width: '100%' }}
                                                options={localFilesList}
                                                getOptionLabel={(file) => file}
                                                value={selectedLocalFile}
                                                onChange={(event, newValue) => {
                                                    setSelectedLocalFile(newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label={_(msg`File`)} variant="outlined" size="small" />
                                                )}
                                            />

                                            <Button
                                                size="small"
                                                variant={'contained'}
                                                onClick={() => {
                                                    uploadFile(true)
                                                }}
                                                disabled={!selectedLocalFile ||!formState.isValid}
                                                sx={{ alignSelf: 'flex-end', mt: 2 }}
                                            >
                                                <Typography>{_(msg`Upload`)}</Typography>
                                            </Button>
                                        </Grid>
                                    )}


                                </Box>
                            )}
                            {!isUploading && uploadMessage && (
                                <Grid item xs={12} display={'flex'} flexDirection={'row'} justifyContent={'center'}>
                                    <Typography variant={'h6'}>{uploadMessage}</Typography>
                                </Grid>
                            )}

                            {isUploading && (
                                <Grid xs={12} spacing={10} display={'flex'} flexDirection={'column'}
                                      justifyContent={'center'}>
                                    <UploadFileProgress fileName={file.name} perc={perc}/>
                                </Grid>
                            )}


                        </Grid>
                    </CardContent>
                </Card>
            </Modal>
            {isLoading && <FullPageLoader/>}
        </>
    )
}
export default ModalAddVideo